export default {"src":"/_next/static/media/ic-edit.98d89d19.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};